import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as classNames from 'classnames';
import { debounce } from 'lodash';
import { Autocomplete } from '@emburse/ui-core';
import * as style from './AutocompleteSelect.styl';
/**
 * Generalized Autocomplete component with `Count` and `Checkbox`.
 * `onChange` event is triggered:
 * - When the dropdown is closed
 * - When you remove option from the input box
 */
// eslint-disable-next-line react/display-name
export const AutocompleteSelect = React.forwardRef((props, ref) => {
    const [selectedOptions, setSelectedOptions] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const debouncedOnChange = React.useCallback(debounce((event, value, reason) => {
        props.onChange(event, value, reason);
    }, 2000), [props.onChange]);
    React.useEffect(() => {
        setSelectedOptions(props.value);
    }, [props.value]);
    function handleChange(event, value, reason) {
        setSelectedOptions(value);
        if ((!open || !props.disableCloseOnSelect) && props.onChange && !props.isDebounced) {
            props.onChange(event, value, reason);
        }
        else if ((!open || props.disableCloseOnSelect) && props.onChange && props.isDebounced) {
            debouncedOnChange(event, value, reason);
        }
    }
    function onOpen(event) {
        setOpen(true);
        if (props.onOpen) {
            props.onOpen(event);
        }
    }
    function onClose(event, reason) {
        setOpen(false);
        if (props.onChange && props.disableCloseOnSelect && !props.isDebounced) {
            // checks disableCloseOnSelect to prevent double firing onChange event
            props.onChange(event, selectedOptions, 'selectOption');
        }
        if (props.onClose) {
            props.onClose(event, reason);
        }
    }
    return (_jsx(Autocomplete, Object.assign({ ref: ref }, props, { useVirtualization: true, value: selectedOptions, onChange: handleChange, onOpen: onOpen, onClose: onClose, className: classNames(style.global, { 'autocomplete-truncate-label': props.truncateLabel }) })));
});
